// extracted by mini-css-extract-plugin
var _1 = "DetailsFormCustomerTransferModal-module__available-balance";
var _2 = "DetailsFormCustomerTransferModal-module__button-container";
var _3 = "DetailsFormCustomerTransferModal-module__button-disabled";
var _4 = "DetailsFormCustomerTransferModal-module__button-subcontainer";
var _5 = "DetailsFormCustomerTransferModal-module__close-button";
var _6 = "DetailsFormCustomerTransferModal-module__close-button-container";
var _7 = "DetailsFormCustomerTransferModal-module__container";
var _8 = "DetailsFormCustomerTransferModal-module__container-justify-end";
var _9 = "DetailsFormCustomerTransferModal-module__disabledButton";
var _a = "DetailsFormCustomerTransferModal-module__error-text";
var _b = "DetailsFormCustomerTransferModal-module__filter-container";
var _c = "DetailsFormCustomerTransferModal-module__form-container";
var _d = "DetailsFormCustomerTransferModal-module__full-width";
var _e = "DetailsFormCustomerTransferModal-module__joint-account-details-container";
var _f = "DetailsFormCustomerTransferModal-module__products-container";
var _10 = "DetailsFormCustomerTransferModal-module__remarks-text";
var _11 = "DetailsFormCustomerTransferModal-module__span-2";
var _12 = "DetailsFormCustomerTransferModal-module__test-button";
export { _1 as "available-balance", _2 as "button-container", _3 as "button-disabled", _4 as "button-subcontainer", _5 as "close-button", _6 as "close-button-container", _7 as "container", _8 as "container-justify-end", _9 as "disabledButton", _a as "error-text", _b as "filter-container", _c as "form-container", _d as "full-width", _e as "joint-account-details-container", _f as "products-container", _10 as "remarks-text", _11 as "span-2", _12 as "test-button" }
